<template>
    <b-container fluid>
        <h1 class="mt-4 mb-4">Customers</h1>
        <b-row class="add-order" align-h="end" align-v="center">
            <b-col cols="4" sm="3" md="2">
                <!-- <router-link to="/add-customer"><b-btn>Add Customer</b-btn></router-link> -->
            </b-col>
        </b-row>

        <div v-if="noCustomers">
            <p>You don't have any customers.</p>
        </div>
        <Table class="table" v-if="items.length>0" :items="items" :fields="fields" :hasEditCustomerButton="true" :hasDeleteCustomerButton="true"/>

        <Loader v-else :class="{ hidden: noCustomers }"/>
  </b-container>
</template>

<script>
import Loader from "../../components/Loader"
import { db } from '@/main'
import firebase from 'firebase'
import axios from 'axios'
import Table from "@/components/Table.vue";
export default {
    components: {
        Table,
        Loader
    },
    data() {
        return {
            items: [],
            fields: [
                { key: 'customer', sortable: true },
                { key: 'phone_number', sortable: true },
                { key: 'marketingOpt', sortable: true },
                { key: 'options', sortable: false },
            ],
            noCustomers: false
        }
    },

     async created() {
        const userDoc = await db.collection('users').doc(firebase.auth().currentUser.uid).onSnapshot(async(doc) => {
            const business = doc.data().business;
            const plan = doc.data().plan;
            const trialVar = doc.data().trialTextsFinished;
            if ((trialVar ==1) && (plan == 'trial')) {
                vueInstance.$router.push({path: '/subscription'});
            }

            const snapshot = await firebase.firestore().collection('businesses').doc(business).collection('customers').orderBy('customer')
            .onSnapshot(querySnapshot => {
                const openArray = querySnapshot.docs.map(doc => doc.data());
                querySnapshot.forEach(doc => {
                })
                this.items = openArray;
                if (this.items.length==0) {
                    this.noCustomers = true;
                }
            });
        });
    },
}
</script>

<style scoped>
.hidden {
  visibility: hidden !important;
  /* transition: all 0.5s ease; */
}

.table {
    margin-top: 30px;
}
</style>
